import React from "react";
import { IoIosArrowDown } from "react-icons/io";

import { cn } from "@/styles/cn";
import { IGIREMenuItem } from "@/router/models/router.types";

type ItemLevel0TemplateProps = {
  item: IGIREMenuItem;
};

export const ItemLevel0Template = React.forwardRef(function ItemLevel0Template(
  { item, ...props }: ItemLevel0TemplateProps & React.ButtonHTMLAttributes<HTMLButtonElement>,
  ref: React.Ref<HTMLButtonElement>,
) {
  return (
    <button
      ref={ref}
      className={cn(
        "flex cursor-pointer items-center gap-1 p-2 text-sm text-urbix-gray-1000 outline-0 hover:bg-urbix-gray-200",
        {
          "text-primary-800": item.active,
        },
      )}
      type="button"
      {...props}
    >
      {item.icon}
      <span>{item.label}</span>
      <IoIosArrowDown className={cn("submenuIcon transition")} size={18} />
    </button>
  );
});

ItemLevel0Template.displayName = "ItemLevel0Template";
